const carousel = document.querySelector('.carousel');
let isCarouselExist = false;

carousel ? isCarouselExist = true : false;

export { isCarouselExist }
